module.exports = {
    aggregatorTitle:'Aggregator MKT',
    sumOfToday:'sum of yesterday',
    cost:'Cost',
    dashboard:'Dashboard',
    report:'Report',
    creative:'Creatives',
    setting:'Setting',
    performanceOverview:'Performance Overview',
    basicInformation:'Basic Information',
    dataView:'Data View',
    trackingStatistics:'Tracking Statistics',
    filters:'Filters',
    timeIntervel:'Time Interval',
    dateRange:'Date Range',
    addNew:'Add New',
    importAffiliate:'Import Affiliate',
    searchByCreativeName:'Search by Creative Name',
    SearchByAffID:'Search by Aff ID',
    tipsMap:{
        tips1:'The original Aff ID was not found, please fill in the correct one',
        tips2:'You already have the same original Aff ID, you cannot create it here',
        tips3:'Please select at least one item in Tracking Statistics to get the result',
    },
    disps:'Provide you with massive and unique media resource cases',
    top5Campaigns: 'Latest Top 5 Campaigns',
    opition_check:'Data can be added only when agency name, package name, and source are all filled in',
    opition_check2:'Data can be added only when apitoken,apitoken, package name, and source are all filled in',
    campaign: 'Campaign',
    seemore:'See More',
    mediaSourceId: 'Media Source ID',
    mediasource: 'Media Source',
    country: 'Country',
    advertiser: 'Advertiser',
    click: 'Click',
    order: 'Order',
    costUsd: 'Cost(USD)',
    costLocalCurrency: 'Cost(Local Currency)',
    enterFilterMediaSourceId: 'Please enter filter media source id',
    enterFilterMediaSource: 'Please enter filter media source',
    enterFilterCountry: 'Please enter filter country',
    enterFilterAdvertiser: 'Please enter filter advertiser',

    enterFilteraffId:'Please enter Original Aff ID'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/aggregator/en.js